import { observer } from 'mobx-react';
import { useEffect } from 'react';
import { warnAndNotify } from '../../../../Honeybadger';
import SegmentStore from '../../../../SegmentStore';
import * as fieldStyle from '../../FormField/style.module.css';
import { StringFormField } from '../../Types';
import { formatInputValue, inputValue } from '../Helpers';
import { useFormField } from '../hooks';
import Label from '../Label';
import * as style from './style.module.css';

interface Props {
  segmentStore: SegmentStore;
  fieldDescription: StringFormField;
  uuid: string;
}

function StringField({ segmentStore, fieldDescription, uuid }: Props) {
  const { fieldValue, isRequired, addValue } = useFormField(segmentStore, fieldDescription, uuid);
  const textareaId = `textarea-${uuid}`;

  useEffect(() => {
    if (!Array.isArray(fieldValue)) {
      warnAndNotify(
        'badPayload',
        `The wrong data is comming StringFieldComponent from useFormField hook`,
        fieldValue,
      );
    }
  }, []);

  return (
    <div className={fieldStyle.field}>
      <Label label={fieldDescription.label} htmlFor={textareaId} />
      <textarea
        id={textareaId}
        name={fieldDescription.name}
        value={inputValue(fieldDescription, fieldValue)}
        required={isRequired}
        minLength={fieldDescription.minlength.getOrElseValue(0)}
        maxLength={fieldDescription.maxlength}
        onChange={(e) => addValue(formatInputValue(fieldDescription, e.currentTarget.value))}
        className={style.textArea}
      />
    </div>
  );
}

export default observer(StringField);
